import { useDispatch, useSelector } from "react-redux";
import { downloadTradeByProductsReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useTradeByProductsReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.exchbusiness.tradeByProducts.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadTradeByProductsReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
